import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchPieChartDataApi,
  fetchClientAnalyticsApi,
} from "../../api/dashboardApi";

export const fetchPieChartData = createAsyncThunk(
  "dashboard/fetchPieChartData",
  async ({ coachId, startDate, endDate }, { rejectWithValue }) => {
    try {
      const data = await fetchPieChartDataApi(coachId, startDate, endDate);
      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch PieChart data");
    }
  }
);

// New Thunk to fetch client analytics
export const fetchClientAnalytics = createAsyncThunk(
  "dashboard/fetchClientAnalytics",
  async ({ coachId, startDate, endDate }, { rejectWithValue }) => {
    try {
      const data = await fetchClientAnalyticsApi(coachId, startDate, endDate);
      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch Client Analytics data");
    }
  }
);

// Slice for dashboard
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    pieChartData: null,
    clientAnalytics: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPieChartData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPieChartData.fulfilled, (state, action) => {
        state.loading = false;
        state.pieChartData = action.payload;
      })
      .addCase(fetchPieChartData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchClientAnalytics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientAnalytics.fulfilled, (state, action) => {
        state.loading = false;
        state.clientAnalytics = action.payload;
      })
      .addCase(fetchClientAnalytics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dashboardSlice.reducer;
